module.exports = __webpack_public_path__ + "img/PlayNext.bc8d6ced.svg";